// API endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/login',
    LOGOUT: '/api/logout',
    REFRESH: '/api/refresh',
    USER: '/api/user'
  },  
  TELE_CRM: {
    DASHBOARD: '/api/v1/tele-crm/dashboard',
    MESSAGE_ACTIVITY: '/api/v1/tele-crm/dashboard/message-activity',
    STAFF_PRODUCTIVITY_OVERVIEW: '/api/v1/tele-crm/dashboard/staff-productivity-overview',
    STAFF_LIST: '/api/v1/tele-crm/dashboard/staff-list',
    ART_TREND_CHART: '/api/v1/tele-crm/dashboard/art-trend-chart',
    RESPONSE_COUNT_TREND_CHART: '/api/v1/tele-crm/dashboard/response-count-trend-chart',
    CONVERSATION_EVALUATIONS: '/api/v1/tele-crm/conversation-evaluations'
  }
}

// Permission constants
export const PERMISSIONS = {
  VIEW_DASHBOARD: 'view-dashboard',
  VIEW_AD_ACCOUNTS: 'view-ad-accounts',
  VIEW_VIA_FACEBOOK: 'view-via-facebook',
  VIEW_BILLING: 'view-billing',
  VIEW_CAMPAIGNS: 'view-campaigns',
  VIEW_USERS: 'view-users',
  VIEW_ROLES: 'view-roles',
  VIEW_BANK: 'view-bank',
  VIEW_TELEGRAM: 'view-telegram',
  VIEW_RENTAL: 'view-rental',
  VIEW_BANK_INVOICES: 'view-bank-invoices',
  VIEW_PAYMENT_INVOICES: 'view-payment-invoices',
  VIEW_FINANCIAL_DASHBOARD: 'view-financial-dashboard',
}

// Status constants
export const STATUS = {
  ACTIVE: 1,
  INACTIVE: 0,
  PENDING: 2,
  SUSPENDED: 3
}

export const ACCOUNT_STATUS = {
  [STATUS.ACTIVE]: { label: 'Hoạt động', color: 'green' },
  [STATUS.INACTIVE]: { label: 'Tạm ngưng', color: 'red' },
  [STATUS.PENDING]: { label: 'Chờ duyệt', color: 'yellow' },
  [STATUS.SUSPENDED]: { label: 'Bị khóa', color: 'gray' }
}

// Pagination constants
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
  MAX_PAGE_SIZE: 200
}

// Date formats
export const DATE_FORMATS = {
  SHORT: 'dd/MM/yyyy',
  LONG: 'dd/MM/yyyy HH:mm:ss',
  ISO: 'yyyy-MM-dd',
  TIME: 'HH:mm:ss'
}

// File types
export const FILE_TYPES = {
  EXCEL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV: 'text/csv',
  PDF: 'application/pdf',
  IMAGE: 'image/*'
}

// Auto refresh intervals (in milliseconds)
export const AUTO_REFRESH_INTERVALS = {
  DISABLED: 0,
  FAST: 10000,      // 10 seconds
  NORMAL: 30000,    // 30 seconds
  SLOW: 60000,      // 1 minute
  VERY_SLOW: 300000 // 5 minutes
}

// Notification types
export const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info'
}

// Theme colors (matching Tailwind config)
export const COLORS = {
  PRIMARY: {
    50: '#f0fdf4',
    500: '#10b981',
    600: '#059669',
    700: '#047857'
  },
  GRAY: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827'
  }
}

// Local storage keys
export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER: 'user',
  SIDEBAR_COLLAPSED: 'sidebarCollapsed',
  AUTO_REFRESH_ENABLED: 'autoRefreshEnabled',
  AUTO_REFRESH_INTERVAL: 'autoRefreshInterval',
  TABLE_PAGE_SIZE: 'tablePageSize',
  THEME: 'theme'
}

// Regex patterns
export const REGEX_PATTERNS = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^(0|\+84)[0-9]{9,10}$/,
  FACEBOOK_ID: /^[0-9]+$/,
  URL: /^https?:\/\/.+/
}

// Error messages
export const ERROR_MESSAGES = {
  NETWORK: 'Lỗi kết nối mạng. Vui lòng kiểm tra kết nối internet.',
  UNAUTHORIZED: 'Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.',
  FORBIDDEN: 'Bạn không có quyền thực hiện hành động này.',
  NOT_FOUND: 'Không tìm thấy dữ liệu yêu cầu.',
  SERVER_ERROR: 'Lỗi máy chủ. Vui lòng thử lại sau.',
  VALIDATION: 'Dữ liệu không hợp lệ. Vui lòng kiểm tra lại.',
  GENERIC: 'Có lỗi xảy ra. Vui lòng thử lại sau.'
}

// Success messages
export const SUCCESS_MESSAGES = {
  LOGIN: 'Đăng nhập thành công!',
  LOGOUT: 'Đăng xuất thành công!',
  SAVE: 'Lưu dữ liệu thành công!',
  DELETE: 'Xóa dữ liệu thành công!',
  UPDATE: 'Cập nhật dữ liệu thành công!',
  EXPORT: 'Xuất dữ liệu thành công!',
  COPY: 'Đã sao chép vào clipboard!'
}
